export const assessmentTypes = {
  PORTEIRO: 'PT',
  TESTE_SITUACIONAL: 'TS'
}
